import { useDBAdata, useGeneralFormT1, useLevelCard, useUtilsNavigation } from "./hooks"
import { Fragment, useEffect, useMemo, useState } from 'react';
import Popup from "../../components/popup/popup";
import { useTranslation } from "react-i18next";
import { StepIndicator } from "../../components/StepIndicator";
import Check from "../../assets/icons/check.svg";
import Button from '../../components/button/button';
import { configuration, iconslevels } from './config';
import { MarkDownViwer } from "../../components/markDownViwer";
import TextArea2 from "../../components/form-elements/TextArea2/textArea2";
import { ButtonsControlsDelete, Header1, Modal, ModalConfirmDelete, useModal, useModalConfirm } from "../../components/form-elements/Modals";
import { useInputValidations } from "../../hooks/useInput";
import { v4 as uuidv4 } from "uuid";
import { DateAddedViwer, HeaderInputComponent, LabelError, LoadIndicator } from "../../components/Labels";
import classNames from "classnames";
import { clearMarkdown } from "../../services/chat.service";
import { SelectableInput, SelectableInputAsyncSearch, useSelectAsyncSearch } from "../../components/Select";
import TextInput2 from "../../components/form-elements/TexInput2/TextInput2";
import DaySelector from "../../components/form-elements/daySelector/daySelector";
import { useSwitchInstitution } from "../../hooks/useIntitution";
import { getInstitutionsByName } from "../../services/institution";
import { getknowledgearea } from "../../services/dba.service";
import { useFormContext } from "react-hook-form";
import shaia from '../../assets/new_shaia.png';
import SuperpowerFormSkeleton from "../../components/skeletons/SuperpowerFormSkeleton";


export const CalendaryInput = ({ viewmode }) => {
    const { t } = useTranslation();
    const [selected, setSelected] = useState([]);
    const { formState: { errors }, watch } = useFormContext();
    const calendario = watch("calendario");
    useEffect(() => {
        setTimeout(() => {
            setSelected(calendario ?? []);
        }, 100);
        // eslint-disable-next-line
    }, [JSON.stringify(calendario)]);
    return (
        <div className="input-row flex flex-col ">
            <div>
                <DaySelector
                    viewmode={viewmode}
                    Header={() => <HeaderInputComponent viewmode={viewmode} labelkey={"perfil_de_curso_formulario_calendario"} labelInstruction={viewmode ? null : "perfil_de_curso_formulario_calendario_instruction"} />}
                    label={t("perfil_de_curso_formulario_calendario")}
                    labelInstruction={t(
                        "perfil_de_curso_formulario_calendario_instruction"
                    )}
                    className="my-0"
                    selectedData={selected}
                />
            </div>
            {errors?.calendario ? (
                <div className="text-Red-500 text-sm font-semibold pt-4 text-center">
                    {t("campo_requerido")}
                </div>
            ) : <div className="text-Red-500 text-sm font-semibold pt-4 text-center">&nbsp;</div>}
        </div>
    );
}

/**
 * Componnete para pedir la confirmacion antes de borrar un objetivo
 * @param {*} param0 
 * @returns 
 */
const DeleteObjective = ({ removeobjetivesOptions, option }) => {

    const { t } = useTranslation();

    const { closeModal, openModal, bind } = useModalConfirm();

    const handleClickAccept = () => {
        removeobjetivesOptions(option.id);
        closeModal();
    }
    return (
        <>
            <Button
                label={t("remove")}
                typeB={"button"}
                variant={"red-text"}
                onClick={openModal}
            />
            <ModalConfirmDelete
                {...bind}
                onClickAccept={handleClickAccept}
                Header={() => <Header1
                    keymessage={"action_irreversible_objective_deleted"}
                    typekey={"learning_objective"} />}
                ButtonsControls={(btnProps) => <ButtonsControlsDelete
                    {...btnProps}
                    labelacceptkey="delete_objective"
                    labelclosekey="editor_actividad_boton_cerrar" />}
            />
        </>
    )
}

/**
 * Mustra cada objetivo selecionado y eliminarlo
 * @param {*} param0 
 * @returns 
 */
export const CardObjective = ({ option, removeobjetivesOptions }) => {

    return (
        <div className='w-full bg-LightBlue-175/25 rounded-[8px] p-[16px] '>
            <DateAddedViwer date={option.created_at} />
            <div className='w-full flex gap-[16px] h-fit items-center'>
                <div className='flex h-full items-center flex-1 gap-[16px] text-white text-[16px]'>
                    {
                        option?.option?.map((item, index) => {
                            item = clearMarkdown(item);
                            item = item?.charAt(0)?.toUpperCase?.() + item?.slice?.(1);
                            return <label key={index}>{item}</label>
                        })
                    }
                </div>
                <div className='flex flex-col md:flex-row min-w-[100px] max-w-[250px] justify-end items-center'>
                    {option?.type?.label ? <div className="bg-LightBlue-500 h-[20px] max-w-[100px] md:max-w-[250px] rounded-[8px] text-[12px] text-[white] truncate px-4">{option?.type?.label}</div> : null}
                    <DeleteObjective removeobjetivesOptions={removeobjetivesOptions} option={option} />
                </div>
            </div>
        </div >
    );
};


/**
 * Card para seleccionar el formulario de curso o grupo
 * @param {*} param0 
 * @returns 
 */
export const OptionSelectType = ({ title, description, onClick, customColorTitle }) => {
    return (
        <div className="w-[332px] bg-LightBlue-150/15 rounded-[8px] p-[32px_16px] shadow-2 cursor-pointer text-[16px]" onClick={onClick}>
            <div className={`text-center text-[18px] mb-4 ${customColorTitle}`}><strong>{title}</strong></div>
            <div className="text-center">{description}.</div>
        </div>
    )
}

/**
 * Ventana modal para selecionar el formulario de curso o grupo
 * @returns 
 */
export const SelectType = ({
    menu
}) => {
    const { t, navigate, options } = useUtilsNavigation({ menu })
    return (
        <Popup
            isOpen
            customClassName={"!max-w-[861px] !max-h-[95%]"}
            onClose={() => navigate("/")}
        >
            <>
                <div className="text-center text-white text-[24px] mb-4"><strong>👋{t("activityText3")}</strong></div>
                <div className="text-center text-white text-[24px] mb-4">{t("profile_type_prompt")}:</div>
                <div className="flex flex-wrap sm:flex-nowrap justify-center gap-[32px] text-white">
                    {
                        options.map((option, index) => (
                            <OptionSelectType
                                key={index}
                                title={option.title}
                                description={option.description}
                                customColorTitle={option.customColorTitle}
                                onClick={() => navigate(`/my-classes/${option.type}`)}
                            />
                        ))
                    }
                </div>
            </>
        </Popup>
    )
}

/**
 * Card para los niveles 
 * @param {*} param0 
 * @returns 
 */
export const LevelCard = ({ option, selected, onClick, viewmode }) => {

    const { levels, t, images } = useLevelCard({ option, _iconslevels: iconslevels });

    const handleOnClick = () => {
        if (viewmode) return;
        onClick?.(option);
    }
    return (
        <div className='w-full sm:w-1/2 md:w-1/3 lg:w-1/3 p-[8px] min-w-[324px]'>
            <div className='w-full flex bg-LightBlue-175/25 rounded-[8px] p-[16px] justify-between cursor-pointer' onClick={handleOnClick}>
                <div className='flex gap-[20px] items-center'>
                    <div className='flex w-[40px]'>
                        {images.map((image, index) => {
                            return <img key={index} className={`relative ${!index ? "z-10" : "left-[-17px]"}`} src={image.icon} alt={image.alt} />
                        })}
                    </div>
                    <div className="flex flex-col items-center justify-start">
                        <div className="whitespace-nowrap w-full text-justify">
                            <strong>
                                {levels.map((level, index) => {
                                    return <span key={index} className={`text-[16px] text-${level.color}`}>{level.level}</span>
                                })}
                            </strong>
                        </div>
                        {
                            viewmode ?
                                <div className="text-[14px] text-white whitespace-nowrap">{t("courseProfile_studentsNTitle")}:&nbsp;{option?.studentsNumber ?? 0}</div> :
                                null
                        }
                    </div>
                </div>
                {viewmode ? null : <div className='text-LightBlue-500 underline flex items-center'>
                    {selected ? <img src={Check} alt='img-check' className='' />
                        : t("biblioteca_boton_seleccionar")}
                </div>}
            </div>
        </div>
    );
}

/**
 * Componente para selecionar los niveles
 * @param param0 
 * @returns 
 */
export const SelectLevel = ({ readonly, viewmode, optionsLevel, methods, limit, fieldArraylevels, labelkey, instructionkey, howmanystudentskey }) => {
    const { t, i18n } = useTranslation();
    const { register } = methods;
    const { fields, append, remove } = fieldArraylevels;
    const { onKeyDownRegexp } = useInputValidations();

    const searchIndex = (option) => {
        return fields.findIndex(item => item.nivel === option.nivel);
    }

    const handleOnClick = (option) => {
        const indexToRemove = searchIndex(option);
        if (indexToRemove !== -1) remove(indexToRemove);
        else if (!limit?.length || limit[1] > fields.length) append(option);
    };

    return (
        <div className={classNames('w-full p-[16px] grid bg-LightBlue-150/15 radius-[8px] rounded-[8px]', { "mb-8": viewmode })}>
            {labelkey ? <label className="input-label px-0">
                {t(labelkey)}
            </label> : null}
            {instructionkey && !readonly && !viewmode ? <label className="input-instruction px-0">
                {t(instructionkey)}.
            </label> : null}
            <div className="w-full flex flex-wrap">
                {!optionsLevel?.length ?
                    <>
                        <label className="text-[20px] font-bold text-DarkBlue-300 w-full">
                            {t("teaching_area_not_selected")}
                        </label>
                        <label className="text-[16px] font-bold text-DarkBlue-300 w-full">
                            {t("select_teaching_area_and_grouping")}
                        </label>
                    </>
                    : null}
                {(!viewmode ? optionsLevel : fields).map((option, index) => (<LevelCard viewmode={viewmode} key={index} onClick={handleOnClick} option={option} selected={searchIndex(option) >= 0} />))}
            </div>
            {
                readonly || viewmode ? null :
                    <>
                        <div className='w-full flex flex-wrap gap-[8px]'>
                            {
                                fields.map((item, index) => {
                                    return (
                                        <Fragment key={index}>
                                            {!index ?
                                                <div className='flex justify-center items-center'>
                                                    <label className="input-label text-[14px] pr-[16px]">
                                                        {i18n.language === "en" ? "" : "¿"}{t(howmanystudentskey)}?
                                                    </label>
                                                </div>
                                                : null}
                                            <div className='grid'>
                                                <label className="input-label text-[16px] text-[white] w-fit">
                                                    {item.nivel}
                                                </label>
                                                <input
                                                    {...register(`levels[${index}].studentsNumber`, { required: t("campo_requerido"), min: { value: 1, message: t("minimum", { min: 1 }) } })}
                                                    className="input-box"
                                                    onKeyDown={onKeyDownRegexp(/^[0-9]+$/)}
                                                    placeholder={t("ex", { example: 10 })}
                                                />
                                                <LabelError errors={methods?.formState?.errors} name={`levels.${index}.studentsNumber`} />
                                            </div>
                                        </Fragment>

                                    );
                                })
                            }
                        </div>
                        <LabelError errors={methods?.formState?.errors} name={"levelscount"} />
                    </>
            }
        </div>
    )
}

/**
 * Card para los objetivos
 * @param {*} param0 
 * @returns 
 */
export const OptionsViwerCard = ({ option, index, onClickModify, onClickSelect, edited }) => {
    const { t } = useTranslation();
    return (
        <div className='flex flex-col flex-1 bg-LightBlue-175/25 rounded-[8px] p-[16px]'>
            <div className={'w-full flex input-label justify-end text-[14px] font-black' + (edited ? " text-Yellow-500" : "")}>{t("option_n", { n: index + 1 }).toUpperCase()}&nbsp;&nbsp;{edited ? `(${t("modified")})`.toUpperCase() : null}</div>
            <div className='text-[16px] text-white flex-1'>
                {option?.map((item, index) => <Fragment key={index}><MarkDownViwer markdown={item} /><br></br></Fragment>)}
            </div>
            <div className='flex w-full justify-end gap-[16px]'>
                <Button
                    typeB={"button"}
                    variant={"secondary-text"}
                    onClick={onClickModify}
                    label={t("editor_barra_boton_modificar")} />
                <Button
                    typeB={"editor_barra_boton_modificar"}
                    onClick={onClickSelect}
                    variant={"primary-text"}
                    label={t("biblioteca_boton_seleccionar")} />
            </div>
        </div>
    );
}

/**
 * Permite ver las opciones que genera gpt
 * @returns 
 */
export const OptionsViwer = ({ options, afterAppend, headers, ButtonsControls, modifyObjetives, methods, loading, onClickHaveAnotherOption, onClickGenerateNewOptions, resetOptions, fieldArrayObjetivesOptions, objectiveskey, objectivessesionkey }) => {
    const { t } = useTranslation();
    const { append } = fieldArrayObjetivesOptions;

    const handleClickModify = (option, index) => () => {
        modifyObjetives({ index, option });
    }

    const handleClickSelect = (option) => () => {
        option?.option?.forEach((item) => {
            append({ ...option, option: [item], id: uuidv4() });
        });
        resetOptions();
        afterAppend?.();
    }
    return (
        <>
            <div className='w-full'>
                <label className="input-label px-0">
                    {t(objectiveskey)}
                </label>
                {loading ?
                    <>
                        <label className="input-instruction px-0 py-0 min-h-[30px] my-4">
                            {t("generating_new_options_in_the_meantime")}
                        </label>
                        <label className="input-instruction px-[20px] py-[0px] mb-4">
                            <strong>"{t("did_you_know_student_variability")}"</strong>
                        </label>
                        <LoadIndicator label={t("please_wait")} />
                    </>
                    :
                    <>
                        <label className="input-instruction px-0 my-4">
                            {headers?.[0]?.headers?.[0] ? <MarkDownViwer markdown={headers?.[0]?.headers?.[0]} /> : t(objectivessesionkey)}
                        </label>
                        <div className='flex gap-[16px] flex-wrap mb-4'>
                            {options.map((option, index) => <OptionsViwerCard edited={option?.edited} onClickModify={handleClickModify(option, index)} onClickSelect={handleClickSelect(option)} key={index} index={index} option={option?.option} />)}
                        </div>
                        <div className='flex w-full gap-[16px]'>
                            <Button
                                customClassName='w-[50%]'
                                typeB={"button"}
                                variant={"primary"}
                                onClick={onClickGenerateNewOptions}
                                label={t("generate_new_options")}
                            />
                            <Button
                                customClassName='w-[50%]'
                                onClick={onClickHaveAnotherOption}
                                typeB={"button"}
                                variant={"secondary"}
                                label={t("i_have_a_different_option")}
                            />
                        </div>
                    </>}
            </div>
            <ButtonsControls />
        </>
    );
}


/**
 * Muestra el campo de texto para el formulario, y un boton de validar
 * @param {*} param0 
 * @returns 
 */
export const InputValidator = ({ required, showOnlyheader, classNameInput, disabledInput, onClick, loading, labelinput, labelInstruction, name, placeHolder, labelInstructio2, labelInstructio3, buttonlabel, loadindicatorlabel }) => {
    const { t } = useTranslation();
    return (
        <>
            <div >
                {showOnlyheader ?
                    <HeaderInputComponent
                        labelInstruction={labelInstruction}
                        labelInstructio2={labelInstructio2}
                        labelInstructio3={labelInstructio3}
                    />
                    :
                    <TextArea2
                        label={t(labelinput)}
                        header={<HeaderInputComponent
                            labelInstruction={labelInstruction}
                            labelInstructio2={labelInstructio2}
                            labelInstructio3={labelInstructio3}
                        />}
                        disabled={disabledInput}
                        name={name}
                        placeholder={t(placeHolder)}
                        maxLength={"500"}
                        className={classNames('w-full h-[100px]', classNameInput)}
                        labelClassName='px-0'
                        required={required}
                    />
                }
            </div>
            {loading ?
                <div className='w-full flex justify-start'>
                    <LoadIndicator label={t(loadindicatorlabel)} />
                </div> :
                <div className='w-full flex justify-end'>
                    <Button
                        label={t(buttonlabel)}
                        variant="secondary"
                        typeB={"button"}
                        onClick={onClick}
                    />
                </div>
            }
        </>
    )
}

/**
 * Cabecera del formulario con pasos
 * @param {*} param0 
 * @returns 
 */
export const HeaderFormWithSteps = ({
    option,
    bindstep,
    step
}) => {
    const { t, language } = useUtilsNavigation();
    return (
        <div>
            {
                step === 1 ?
                    <>
                        <div className="text-center text-white text-[24px]"><strong>👋{t("activityText3")}</strong></div>
                        <div className="text-center text-white text-[24px]">{language === "en" ? "" : "¿"}{t("are_you_ready_to_create_a")}&nbsp;<label className='text-LightBlue-500'>{option}</label>?</div>
                        <div className="text-center text-white text-[24px]">{t("lets_start")}</div>
                    </>
                    :
                    <div className="text-center text-white text-[24px] px-1 md:px-[25%]">{t("we_are_making_progress_before_your_coffee_is_ready_we_will_be_done")}</div>
            }
            <div className="text-center text-white text-[24px] mt-4"><StepIndicator {...bindstep} /></div>
        </div>
    );
}

/**
 * Base para contruir una pantalla de formulario
 * @param {*} param0 
 * @returns 
 */
export const ScreenForm = ({ children }) => {
    return (
        <>
            <div className="wrapper-home relative overflow-hidden">
                <div className="bg-DarkBlue-700/90 rounded-2xl flex flex-col gap-5 p-5 w-full h-full">
                    {children[0]}
                    <div className="flex flex-1 justify-center overflow-y-auto overflow-x-hidden">
                        {children[1]}
                    </div>
                </div >
            </div >
        </>
    )
}

export const SkeletonClass = () => {
    return (
        <SuperpowerFormSkeleton />
    )
}

export const NotFound = () => {
    return (
        <ScreenForm>
            <></>
            <div className="flex flex-col gap-4 justify-center items-center text-[white] text-[20px] bold">404 not found</div>
        </ScreenForm>
    )
}


export const GeneralFormT1 = ({
    methods,
    customs,
    readonly,
    keyslabels = {} }) => {
    const {
        general_select_institution = "general_select_institution",
        general_select_institution_name = "general_select_institution_name",
        general_institution = "general_institution",
        general_course_name = "general_course_name",
        general_enter_name_to_identify = "general_enter_name_to_identify",
        general_example_group_01_morning_shift = "general_example_group_01_morning_shift",
        general_select_grade = "general_select_grade",
        general_select_grade_for_course = "general_select_grade_for_course",
        general_grade = "general_grade",
        general_select_teaching_area = "general_select_teaching_area",
        general_subject = "general_subject",
        general_select_or_write_subject = "general_select_or_write_subject",
        general_number_of_students = "general_number_of_students",
        general_indicate_number_of_students = "general_indicate_number_of_students",
        general_enter_number_of_students_example = "general_enter_number_of_students_example",
        general_select_or_create_resources = "general_select_or_create_resources",
        general_available_materials_and_resources = "general_available_materials_and_resources",
        general_select_available_resources = "general_select_available_resources",
        general_additional_context = "general_additional_context",
        general_share_key_details = "general_share_key_details",
        general_students_demotivate_easily = "general_students_demotivate_easily"
    } = keyslabels;
    const { t, grades, subjecAreas } = useGeneralFormT1({ methods });
    return (
        <div>
            <div className="flex flex-wrap gap-2">
                <div className="flex-1 min-w-[200px]">
                    <SelectableInputAsyncSearch
                        rules={{ required: t("campo_requerido") }}
                        placeHolder={t(general_select_institution)}
                        label={t(general_institution)}
                        labelInstruction={t(general_select_institution_name) + "."}
                        name={"institution"}
                        isDisabled={readonly}
                        viewmode={readonly}
                        queryfn={getInstitutionsByName}
                    />
                </div>
                <div className="flex-1 min-w-[200px]">
                    <TextInput2
                        HeaderComponent={() => <HeaderInputComponent viewmode={readonly} labelkey={general_course_name} labelInstruction={readonly ? null : general_enter_name_to_identify} />}
                        name="name"
                        placeHolder={t(general_example_group_01_morning_shift)}
                        maxLength={"60"}
                        customClassName={"mt-0 h-full"}
                        classNameLabel="p-0"
                        classNameInstruction="px-0"
                        required
                        viewmode={readonly}
                    />
                </div>
            </div>

            <div className="flex flex-wrap gap-2">
                <div className="flex-1 min-w-[200px]">
                    <SelectableInput
                        rules={{ required: t("campo_requerido") }}
                        placeHolder={t(general_select_grade)}
                        label={t(general_grade)}
                        labelInstruction={t(general_select_grade_for_course)}
                        name={"grade"}
                        options={grades}
                        isDisabled={readonly}
                        viewmode={readonly}
                    />
                </div>
                <div className="flex-1 min-w-[200px]">
                    <SelectableInput
                        rules={{ required: t("campo_requerido") }}
                        placeHolder={t(general_select_teaching_area)}
                        label={t(general_subject)}
                        labelInstruction={t(general_select_or_write_subject)}
                        name={"asignature"}
                        options={subjecAreas}
                        isDisabled={readonly}
                        viewmode={readonly}
                    />
                </div>
            </div>

            <div className="flex flex-wrap gap-2">
                <div className="flex-1 min-w-[200px]">
                    <TextInput2
                        HeaderComponent={() => <HeaderInputComponent viewmode={readonly} labelkey={general_number_of_students} labelInstruction={readonly ? null : general_indicate_number_of_students} />}
                        name="studentsNumber"
                        placeHolder={t(general_enter_number_of_students_example)}
                        maxLength={"60"}
                        customClassName={"mt-0 h-full"}
                        classNameLabel="p-0"
                        classNameInstruction="px-0"
                        required
                        viewmode={readonly}
                    />
                </div>
                <div className="flex-1 min-w-[200px]">
                    {
                        customs?.[0] ?
                            customs?.[0]
                            :
                            <SelectableInput
                                rules={{ required: t("campo_requerido") }}
                                placeHolder={t(general_select_or_create_resources)}
                                label={t(general_available_materials_and_resources)}
                                labelInstruction={t(general_select_available_resources)}
                                name={"resources"}
                                options={[]}
                                isMulti
                                isDisabled={readonly}
                                viewmode={readonly}
                            />
                    }
                </div>
            </div>

            {
                customs?.[1]
            }

            <CalendaryInput viewmode={readonly} />

            <SelectableInput
                placeHolder={t(general_students_demotivate_easily)}
                label={t(general_additional_context)}
                labelInstruction={t(general_share_key_details)}
                labelInstructio4={t("formulario_bc_session_campo_recurso_indicacion")}
                name={"considerations"}
                isMulti
                options={[]}
                viewmode={readonly}
                isDisabled={readonly}
            />
        </div>
    )
}

/**
 * 
 * @param {*} param0 
 * @returns 
 */
export const DBAForm = ({ methods }) => {
    const { t } = useTranslation();
    const { options } = useSelectAsyncSearch({ queryfn: getknowledgearea, loadInStart: true, formatfn: (data) => data?.map?.(i => ({ label: i.knowledge_area, value: i.knowledge_area })) });
    const { dbaoptions, isLoading } = useDBAdata({ methods });
    return (
        < >
            <HeaderInputComponent labelkey="general_dba_colombia" labelInstruction="general_which_dba_to_include" />
            <div className="flex flex-wrap gap-2 my-8">
                <div className="flex-1 min-w-[200px]">
                    <SelectableInput
                        placeHolder={t("general_select_knowledge_area")}
                        label={t("general_knowledge_area")}
                        labelInstruction={t("general_select_knowledge_area")}
                        name={"knowledge_area"}
                        options={options}
                    />
                </div>
                <div className="flex-1 min-w-[200px]">
                    <SelectableInput
                        placeHolder={t("general_select_standard")}
                        label={t("general_standard_dba")}
                        labelInstruction={t("general_select_standard_dba")}
                        name={"objectiveinput"}
                        isLoading={isLoading}
                        options={dbaoptions}
                    />
                </div>
            </div>
        </>
    );
}

export const ObjectivesFormByOptions = ({ objectiveType, config, methods }) => {
    const { t } = useTranslation();
    const { watch } = methods;
    const grade = watch("grade");

    const optionsMC = useMemo(() => {
        return config?.options?.optionsMC?.filter(item => item?.conditional?.includes(grade?.label));
    }, [grade, config?.options?.optionsMC]);

    if (objectiveType?.code === "OP") return <TextArea2
        header={<HeaderInputComponent
            labelkey="general_custom_objective"
            labelInstruction={"general_which_learning_objectives"}
        />}
        name={"objectiveinput"}
        placeholder={t("general_leave_your_comment")}
        maxLength={"500"}
        className={'w-full h-[100px]'}
        labelClassName='px-0'
    />
    if (objectiveType?.code === "MC") return <SelectableInput
        placeHolder={t("bc_select_curriculum")}
        label={t("bc_curriculum_suggested_by_bc")}
        labelInstruction={t("general_which_curriculum_to_apply")}
        name={"objectiveinput"}
        options={optionsMC}
    />
    if (objectiveType?.code === "DBA") return <DBAForm methods={methods} />
    return null;
}

export const ObjectivesFormT1 = ({ readonly, methods, addObjectives,_afterAppend }) => {
    const { t } = useTranslation();
    const { config } = useSwitchInstitution({ config: configuration });
    const { watch, setValue, setError } = methods;
    const objectiveType = watch("objectiveType");
    const objectiveinput = watch("objectiveinput");
    const handleOnClick = () => {
        if (objectiveinput?.label ?? objectiveinput) {
            addObjectives({ id: objectiveinput?.id ?? null, option: [objectiveinput?.label ?? objectiveinput], type: objectiveType });
            _afterAppend?.();
        } else {
            setError("objectiveinput", {
                type: "manual",
                message: t("campo_requerido"),
            });
            return;
        }
        setValue("objectiveType", null);
        setValue("knowledge_area", null);
    }

    return (
        <>
            <SelectableInput
                placeHolder={t("general_select_objective_type")}
                label={t("general_learning_objectives")}
                name={"objectiveType"}
                labelInstruction={"general_which_learning_objectives"}
                labelInstructio2={t("general_to_start_select_objective_type")}
                options={config?.options?.objectivesTypes}
                isDisabled={readonly}
                viewmode={readonly}
            />
            <ObjectivesFormByOptions config={config} objectiveType={objectiveType} methods={methods} />
            {
                objectiveType?.code ?
                    <div className="w-full flex justify-end">
                        <Button typeB={"button"} onClick={handleOnClick} variant={"secondary"} label={t("general_add")} />
                    </div>
                    : null
            }
        </>
    );
}


/**
 * Base para contruir una pantalla de edicion
 * @param {*} param0 
 * @returns 
 */
export const ScreenViewEdit = ({ children }) => {
    return (
        <>
            <div className="wrapper-home relative sm-max:max-h-[calc(100%-128px)] overflow-hidden">
                <div className="rounded-2xl flex flex-col gap-5 p-5 w-full h-full">
                    {children}
                </div >
            </div >
        </>
    )
}

export const ModalObjectives = ({ Form, afterAppend,className }) => {
    const { openModal, bind, t, closeModal } = useModal();
    const _afterAppend = () => {
        afterAppend?.();
        closeModal();
    }
    return (
        <>
            <Button
                label={t("create_a_new_one")}
                variant="primary"
                typeB={"button"}
                customClassName="whitespace-nowrap h-[60px]"
                onClick={openModal}
            />
            <Modal customClass={classNames("max-h-[800px] w-[700px]", className)} {...bind}>
                <div className="flex w-full items-center gap-[8px]">
                    <img src={shaia} className='w-[24px] h-[24px] rounded-[78px]' alt="Sha.ia" />
                    <HeaderInputComponent labelkey="Shaia" />
                </div>
                <div className='max-h-[600px] overflow-auto'>
                    <Form {...{_afterAppend}}/>
                </div>
                <div className="flex w-full justify-center items-center mt-4">
                    <Button
                        label={t("close")}
                        variant="primary-outline"
                        typeB="button"
                        onClick={closeModal} />
                </div>
            </Modal>
        </>
    )
}